import compose from 'lodash/fp/compose';

import challengeAttemptAPI from '../../firebase/challengeAttempt';
import { paginate, selectable } from '../plugins';
import PluggableModule from '../pluggable';

const securedPointsAndMaxPoints = (criteria, review) => {
  return criteria.reduce(
    (result, criterion) => {
      const rating = review.ratings[criterion.key];
      const weight = criterion.weight;
      return [result[0] + rating * weight, result[1] + 2 * weight];
    },
    [0, 0]
  );
};

export const reviewWithScoresCalculated = (
  criteria,
  review,
  maxPossibleScore
) => {
  const [securedPoints, maxPoints] = securedPointsAndMaxPoints(
    criteria,
    review
  );
  const newReview = { ...review, scores: {} };
  criteria.forEach(criterion => {
    newReview.scores[criterion.key] =
      (review.ratings[criterion.key] * criterion.weight * maxPossibleScore) /
      maxPoints;
  });

  newReview.scores['bonus'] =
    ((review.ratings.bonus || 0) * maxPossibleScore) / maxPoints;

  const finalPoints = Math.min(
    securedPoints + (review.ratings.bonus || 0),
    maxPoints
  );

  newReview['score'] = (finalPoints * maxPossibleScore) / maxPoints;
  return newReview;
};

const challengeAttempts = new PluggableModule('challengeAttempt');

challengeAttempts.addMutationTypes([
  'CHALLENGE_ATTEMPT_SUBMIT_INIT',
  'CHALLENGE_ATTEMPT_SUBMIT_DONE',
  'CHALLENGE_ATTEMPT_SUBMIT_ERROR'
]);

challengeAttempts.extend({
  namespaced: true,
  state: {
    updating: false,
    updateError: null
  },
  mutations: {
    [challengeAttempts.con.CHALLENGE_ATTEMPT_SUBMIT_INIT]: function(state) {
      state.updating = true;
      state.updateError = null;
    },
    [challengeAttempts.con.CHALLENGE_ATTEMPT_SUBMIT_DONE]: function(state) {
      state.updating = false;
    },
    [challengeAttempts.con.CHALLENGE_ATTEMPT_SUBMIT_ERROR]: function(
      state,
      error
    ) {
      state.updating = false;
      state.updateError = error;
    }
  },
  actions: {
    async updateCriticReview(
      { commit, state },
      { criticReview, overallComment, criteria }
    ) {
      commit(challengeAttempts.con.CHALLENGE_ATTEMPT_SUBMIT_INIT);
      const finalCriticReview = reviewWithScoresCalculated(
        criteria,
        criticReview,
        state.selected.difficulty * 10000
      );
      const updatableChallengeAttempt = challengeAttemptAPI.getUpdatable(
        state.selected
      );
      const subjectiveProgress = updatableChallengeAttempt.progress.slice(
        -1
      )[0];
      try {
        await challengeAttemptAPI.update({
          ...updatableChallengeAttempt,
          progress: [
            ...updatableChallengeAttempt.progress.slice(0, -1),
            { ...subjectiveProgress, score: finalCriticReview.score }
          ],
          reviews: {
            ...state.selected.reviews,
            critic: finalCriticReview
          },
          overallComment
        });
        commit(challengeAttempts.con.CHALLENGE_ATTEMPT_SUBMIT_DONE);
      } catch (error) {
        commit(challengeAttempts.con.CHALLENGE_ATTEMPT_SUBMIT_ERROR, error);
      }
    }
  }
});

const hop = compose(
  paginate('challengeAttempts', {
    filterDefinition: {
      challenge: 'reference'
    }
  }),
  selectable(challengeAttemptAPI, false, true)
);

export default hop(challengeAttempts);
